import React, {useCallback, useContext, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {FormProvider, useForm} from "react-hook-form";
import clsx from "clsx";
import {
	Button,
	Card,
	CardActionArea,
	CardActions,
	CardContent,
	CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
	Grid,
	Tooltip,
	Typography
} from "@mui/material";
import {AnagraficaContext} from "../../../../../App";
import FileInput from "../../../carico/utils/FileInput";
import {addAllegatoToUser, getAllegatiBySoggetto} from "../../../../../services/AnagraficaServices";
import {GET_ALLEGATO_ULR} from "../../../../../services/utils/ApiUrls";
import {getAllegatoById} from "../../../ticket/storico/StoricoTicket";
import { Skeleton } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import {Download} from "@mui/icons-material";

const DocumentiSection = ({idSoggetto}) => {
	const classes = BaseStyle();
	const methods = useForm({mode: "onChange"});
	const anagraficaContext = useContext(AnagraficaContext);
	const [file, setFile] = useState("");
	const [idAllegato, setIdAllegato] = useState("");

	const onClick = useCallback((allegato) => {
		setIdAllegato(allegato);
		setFile("open");
	}, [])

	const onSubmit = useCallback((data) => {
		addAllegatoToUser(data, idSoggetto, anagraficaContext.dispatch);
	}, [idSoggetto, anagraficaContext.dispatch])

	useEffect(() => {
		getAllegatiBySoggetto(idSoggetto, anagraficaContext.dispatch)
	}, [idSoggetto, anagraficaContext.dispatch]);

	function cleanName(nomeFile) {
		const indiceUnderscore = nomeFile.lastIndexOf('_');
		if (indiceUnderscore !== -1) {
			const estensione = nomeFile.substring(nomeFile.lastIndexOf('.'));
			return nomeFile.substring(0, indiceUnderscore) + estensione;
		}
		return nomeFile;
	}

	return (
        <React.Fragment>
            <Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Documenti</b></Typography>}
					subheader={"Visualizza o aggiungi documenti per l'anagrafica corrente"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll", scrollbarWidth: "none"}} >
					<FormProvider {...methods}>
						<form onSubmit={methods.handleSubmit(onSubmit)}>
							<Grid container spacing={3}>
								<Grid item xs={12} className={classes.flexStart}>
									{
										anagraficaContext.state.loadingGetAllegati ?
											<Skeleton animation={"wave"} style={{width: "100%", height: 200}}/> :
											anagraficaContext.state.errorGetAllegati !== "" ? "Ops, errore" :
												anagraficaContext.state.allegati.map((allegato, index) => {
													return (
                                                        <Card key={index}
														      className={clsx(classes.roundBorder, classes.margin1, classes.classActionCardNoHover)}
														      style={{
															      height: "auto",
															      width: "auto"
														      }}
														>
                                                            <Tooltip title={"Clicca per scaricare"}>
																<CardActionArea style={{height: "100%"}} onClick={(e) => {
																	e.stopPropagation(); // Per evitare di attivare anche l'onClick principale
																	window.open(`${GET_ALLEGATO_ULR}${allegato.id}`, "_blank");
																}}
																>
																	<CardHeader
																		title={
																			<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
																				<Typography variant={"body2"}>
																					<b>{cleanName(allegato?.fileName)}</b>
																				</Typography>
																				<IconButton
                                                                                    aria-label="download"
                                                                                    style={{ cursor: "default", pointerEvents: "none" }}
                                                                                    size="large">
																					<Download />
																				</IconButton>
																			</div>
																		}
																	/>
																	{/*<CardContent style={{padding: 0}}>*/}
																	{/*	<img*/}
																	{/*		style={{*/}
																	{/*			width: "100%",*/}
																	{/*			height: "auto",*/}
																	{/*			borderRadius: 24*/}
																	{/*		}}*/}
																	{/*		src={GET_ALLEGATO_ULR + allegato.id}*/}
																	{/*		alt={"allegato"}*/}
																	{/*	/>*/}
																	{/*</CardContent>*/}
																</CardActionArea>
															</Tooltip>
                                                        </Card>
                                                    );
												})
									}
								</Grid>
								<Grid item xs={12}>
									<FileInput name={"allegato"} multiple={true} accept={"*"}/>
								</Grid>
							</Grid>
						</form>
					</FormProvider>
				</CardContent>
				<CardActions className={classes.flexRight}>
					<Tooltip
						title={"Aggiungi documenti"}>
						<Button className={classes.roundButton} size={"small"} variant={"contained"} disableElevation
						        style={{borderRadius: 24}} onClick={methods.handleSubmit(onSubmit)}
						        color={"primary"}>
							<b>Aggiungi</b>
						</Button>
					</Tooltip>
				</CardActions>
			</Card>
            {
				file !== "" && <Dialog PaperProps={{
					className: clsx(classes.roundBorder)
				}} open={file !== ""} onClose={() => setFile("")} maxWidth={"lg"} fullWidth={true}>
					<DialogTitle><b>Dettaglio allegato</b></DialogTitle>
					<DialogContent style={{height: 900, overflowY: "scroll"}}>
						<DialogContentText>
							In questa schermata visualizzi solo le anteprime delle immagini, in caso il file sia un pdf o altro non è
							disponibile al momento un' anteprima.
						</DialogContentText>
						<img
							style={{
								width: "100%"
							}}
							src={GET_ALLEGATO_ULR + idAllegato}
							alt={"allegato"}
						/>

					</DialogContent>
					<DialogActions>
						<Button size={"small"} variant={"text"} onClick={() => setFile("")} className={classes.roundButton}
						        style={{borderRadius: 24}}>
							<b>Chiudi</b>
						</Button>
						<Tooltip
							title={"Scarica l'allegato. É possibile che l'operazione non sia immediata, porta pazienza, per natale te lo scarica"}>
							<Button size={"small"} variant={"contained"} color={"primary"} disableElevation
							        className={classes.roundButton} style={{borderRadius: 24}}
							        onClick={() => getAllegatoById(idAllegato)}>
								<b>Scarica</b>
							</Button>
						</Tooltip>
					</DialogActions>
				</Dialog>
			}
        </React.Fragment>
    );
}

export default React.memo(DocumentiSection);
